module.exports = __webpack_public_path__ + "HK.png?c14d3f7142380d4a3880c78209fad907";